import { useTranslation } from 'react-i18next';

export default function VillaflorHero() {
  const { t } = useTranslation();

  const stats = [
    { icon: 'ri-user-star-line', key: 'hero_villaflor_guests' },
    { icon: 'ri-hotel-bed-line', key: 'hero_villaflor_beds' },
    { icon: 'ri-drop-line', key: 'hero_villaflor_baths' },
    { icon: 'ri-ruler-line', key: 'hero_villaflor_size' },
  ];

  return (
    <section
      id="hero"
      className="relative w-full h-[calc(100vh-64px)] md:h-[calc(100vh-80px)] min-h-[500px] md:min-h-[600px] flex items-center justify-center overflow-hidden mt-16 md:mt-20"
    >
      <div className="absolute inset-0">
        <img
          src="https://storage.helloreaddy.io/project_files/f11cd3cf-6b55-4cb4-bc65-73427384328d/744e5944-e504-4454-9f4f-5325c6999fa8_compressed_F5E3E739-2C7B-401F-AAC7-7110DF8776C9.webp"
          alt="Casa De la Villaflor - Private heated pool with turquoise water and sunny terrace in Yaiza Lanzarote"
          title="Casa De la Villaflor - Private Heated Pool Terrace in Lanzarote"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-10 text-center text-white">
        <div className="max-w-4xl mx-auto">
          <p className="font-label text-xs md:text-sm uppercase tracking-[0.25em] mb-3 md:mb-4 animate-fade-in">
            {t('hero_villaflor_location')}
          </p>

          <h1 className="font-heading text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-semibold leading-tight mb-4 md:mb-6 animate-fade-in animation-delay-200">
            Casa De la Villaflor
          </h1>

          <p className="font-heading text-lg md:text-2xl italic font-light mb-6 md:mb-8 animate-fade-in animation-delay-400 text-white/90">
            {t('hero_villaflor_tagline')}
          </p>

          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 mb-8 md:mb-10 animate-fade-in animation-delay-600">
            {stats.map((item) => (
              <div key={item.key} className="flex items-center gap-2 text-sm md:text-base">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className={`${item.icon} text-base`}></i>
                </span>
                <span className="whitespace-nowrap">{t(item.key)}</span>
              </div>
            ))}
          </div>

          <div className="animate-fade-in animation-delay-800">
            <p className="text-3xl md:text-4xl lg:text-5xl font-heading font-semibold mb-2">
              {t('hero_from')} <span className="text-white">€160</span>
              <span className="text-lg md:text-xl font-normal text-white/80"> {t('hero_night')}</span>
            </p>
            <p className="text-sm text-white/70 mb-6">Feb–May: €160/night · Jun–Jan: €190/night</p>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-in animation-delay-800">
            <a
              href="#search"
              className="bg-primary-500 hover:bg-primary-600 text-white px-8 py-3.5 rounded-md text-base font-semibold whitespace-nowrap transition-all duration-300 cursor-pointer w-full sm:w-auto"
            >
              {t('hero_check_availability')}
            </a>
            <a
              href="#search"
              className="bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white border border-white/30 px-8 py-3.5 rounded-md text-base font-semibold whitespace-nowrap transition-all duration-300 cursor-pointer w-full sm:w-auto"
            >
              {t('hero_book_now')}
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-fade-in animation-delay-800">
        <a
          href="#search"
          className="flex flex-col items-center gap-2 text-white/60 hover:text-white transition-colors duration-300 cursor-pointer"
        >
          <span className="text-xs uppercase tracking-widest">{t('hero_scroll')}</span>
          <span className="w-5 h-5 flex items-center justify-center">
            <i className="ri-arrow-down-s-line text-xl animate-bounce"></i>
          </span>
        </a>
      </div>
    </section>
  );
}